const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "About Us", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Equipment", href: "#equipment" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];

const services = [
  "Hospital Turnkey Projects",
  "ICU & Critical Care Equipment",
  "Hospital Furniture",
  "Stainless Steel Equipment",
  "Urology Equipment",
  "Radiology Systems",
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      {/* CTA Banner */}
      <div className="border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-white">Ready to Transform Your Healthcare Facility?</h3>
            <p className="text-gray-400 mt-2">Get expert consultation on hospital equipment and turnkey solutions.</p>
          </div>
          <button
            onClick={() => handleNavClick("#contact")}
            className="whitespace-nowrap px-8 py-3.5 rounded-md font-semibold bg-amber-500 text-white hover:bg-amber-600 transition-colors cursor-pointer flex items-center gap-2 flex-shrink-0"
          >
            Request Consultation <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand Column */}
        <div className="lg:col-span-1">
          <img
            src="https://static.readdy.ai/image/14f0c08496f387da9bb8573a79a50ff5/44e91f8a82e6b4dbd12af647fada7b4b.jpeg"
            alt="ANDINI Logo"
            className="h-14 w-auto object-contain mb-5 brightness-0 invert"
          />
          <p className="text-sm text-gray-400 leading-relaxed mb-6">
            A specialized provider of comprehensive healthcare solutions — delivering high-quality medical equipment and turnkey hospital projects since 2008.
          </p>
          <div className="flex items-center gap-3">
            {["ri-linkedin-fill", "ri-twitter-x-fill", "ri-facebook-fill", "ri-whatsapp-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:bg-amber-500 hover:border-amber-500 hover:text-white transition-all duration-200 cursor-pointer"
                rel="nofollow"
              >
                <i className={`${icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
            <a id="quick-links-anchor" className="block">Quick Links</a>
          </h4>
          <ul className="space-y-3">
            {quickLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                  className="text-sm text-gray-400 hover:text-amber-400 transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-arrow-right-s-line text-amber-500"></i>
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
            <a id="services-footer-anchor" className="block">Our Services</a>
          </h4>
          <ul className="space-y-3">
            {services.map((s) => (
              <li key={s} className="flex items-center gap-2 text-sm text-gray-400">
                <i className="ri-arrow-right-s-line text-amber-500 flex-shrink-0"></i>
                {s}
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-bold text-sm uppercase tracking-widest mb-5">
            <a id="contact-footer-anchor" className="block">Contact Info</a>
          </h4>
          <ul className="space-y-4">
            <li className="flex items-start gap-3">
              <i className="ri-map-pin-line text-amber-500 text-lg flex-shrink-0 mt-0.5"></i>
              <span className="text-sm text-gray-400 leading-relaxed">
                Ostim OSB Mah. 244 sok No:27<br />
                Ostim 06374, Ankara — TURKEY
              </span>
            </li>
            <li className="flex items-center gap-3">
              <i className="ri-phone-line text-amber-500 text-lg flex-shrink-0"></i>
              <a href="tel:+905332663808" className="text-sm text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                +90-312-39503355 &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;+90-533-266 38 08
              </a>
            </li>
            <li className="flex items-center gap-3">
              <i className="ri-mail-line text-amber-500 text-lg flex-shrink-0"></i>
              <a href="mailto:mk@andini.com.tr" className="text-sm text-gray-400 hover:text-amber-400 transition-colors cursor-pointer">
                Sales@andini.com.tr &nbsp; mk@andini.com.tr
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            &copy; {new Date().getFullYear()} ANDINI LTD ŞTİ. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 cursor-pointer" rel="nofollow">Privacy Policy</a>
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 cursor-pointer" rel="nofollow">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
